module.exports = __webpack_public_path__ + "img/06.7ceb1017.png";